import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function ContactCTA() {
  return (
    <section className="py-20 md:py-28">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-2xl border border-brand-cyan/30 bg-gradient-to-br from-brand-purple/15 via-brand-blue/10 to-background p-10 md:p-16"
        >
          <div className="absolute -top-24 -right-24 size-64 rounded-full bg-brand-purple/30 blur-3xl" aria-hidden />
          <div className="absolute -bottom-32 -left-32 size-80 rounded-full bg-brand-cyan/20 blur-3xl" aria-hidden />
          <div className="relative max-w-2xl">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-balance">
              Pronto pra encurtar percursos?
            </h2>
            <p className="mt-4 text-lg text-muted-foreground text-pretty">
              Conta o problema. Em 1 reunião a gente decide se faz sentido seguir — sem compromisso,
              sem proposta inflada.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Button asChild size="lg">
                <Link to="/contato">
                  Solicitar orçamento <ArrowRight className="size-4" />
                </Link>
              </Button>
              <Button asChild size="lg" variant="outline">
                <Link to="/cases">Ver cases primeiro</Link>
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
